
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Container, Modal, Row } from "reactstrap";
import { useRecoilState, useRecoilValue } from "recoil";
import { mailFlightRequest, viewFlightRequest } from "../../../api/controller/CaseReportController";
import { DynamicForm } from "../../../custom/components/DynamicForm";
import { flightSummaryDataStructureState, flightSummaryReportDataState } from "./state";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { handleResponse } from "../../../custom/helpers/HandleResponse";

const FlightSummary = () => {

    const [reportModalVisible, setReportModalVisible] = useState(false)
    const toggleModal = () => {
        if(reportModalVisible){
            setReportData(null)
        }
        setReportModalVisible(!reportModalVisible)
    }

    const [reportData, setReportData] = useRecoilState(flightSummaryReportDataState);
    // eslint-disable-next-line
    const [cuModalConfig, setCUModalConfig] = useState({ header: 'Export Flight Summary', type: "Create", typeKey: 0, data: {}, size: "md", actionName: "View", setReportData: setReportData, subModalTrigger: toggleModal })

    const formModes = { create: [ { name: 'Default Create', action: viewFlightRequest } ], update: [], view: [] }
    const dataStructure = useRecoilValue(flightSummaryDataStructureState)

    useEffect(() => {
        return () => {
            setReportData(null)
        }
        // eslint-disable-next-line
    }, [])

    
    const printForm = () => {
        const printArea = document.getElementById('dynamic-modal')
        const hidden = printArea.getElementsByClassName("print-hidden")
        Array.from(hidden).forEach((h) => h.style.display = "none")
        html2canvas(printArea).then(canvas => {
          Array.from(hidden).forEach((h) => h.style.display = "")
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF();
          pdf.addImage(imgData, 'JPEG', 0, 0);
          // pdf.output('dataurlnewwindow');
          pdf.save(`${reportData.Flight}-${reportData.Date}.pdf`);
        });
      }

      const mailFlight = async() => {
        const response = await mailFlightRequest({FlightDate: reportData?.RawDate, Flight: reportData?.Flight})
        handleResponse(response)
      }
  
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <h3>Flight Report</h3>
                    <Row>
                        <Card className='d-none d-md-block' style={{minHeight:'700px'}}>
                            <CardBody>
                                <h4 style={{color:'white', marginBottom:'25px'}}>Generate</h4>
                                <DynamicForm config={cuModalConfig} ds={dataStructure} submitModes={formModes} />
                            </CardBody>
                        </Card>
                    </Row>
                </Container>

                <Modal size="lg" isOpen={reportModalVisible} toggle={()=>toggleModal({})} keyboard={false} backdrop="static" id="dynamic-modal">
                    <div className="modal-header">
                        <h5 className="modal-title mt-0" id="myModalLabel">Flight Summary | {reportData?.Date} | {reportData?.Flight}</h5>
                        <button type="button" onClick={() => toggleModal({})} className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div id="modalBody" className="modal-body">
                        {reportData?.OriginatedBags.length > 0 ?
                            <>
                                <h4>Bags [Originated]</h4>
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>Reference Number</th>
                                            <th>Tag Number</th>
                                            <th>Received Date</th>
                                            <th>Deliver / Forward Date</th>
                                            <th>Forward Flight / Rush Tag</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reportData?.OriginatedBags.map((bag, idx) => 
                                            <tr key={idx}>
                                                <td>{bag.case_file?.primary_reference}</td>
                                                <td>{bag.tag_number}</td>
                                                <td>{bag.receive_date ? moment(bag.receive_date).format("MMMM Do") : "-"}</td>
                                                <td>{bag.deliver_date ? moment(bag.deliver_date).format("hh:mm | Do MMM") : bag.forward_date ? moment(bag.forward_date).format("Do MMM YYYY") : "-"}</td>
                                                <td>{bag.forward_flight || "-"}{bag.forward_flight && bag.rush_tag_number ? "/"+bag.rush_tag_number : ""}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <br />
                            </>
                        : null}
                        {reportData?.ReceivedBags.length > 0 ?
                            <>
                                <h4>Bags [Received From]</h4>
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>Reference Number</th>
                                            <th>Tag Number</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reportData?.ReceivedBags.map((bag, idx) => 
                                            <tr key={idx}>
                                                <td>{bag.case_file?.primary_reference}</td>
                                                <td>{bag.tag_number}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <br />
                            </>
                        : null}
                        {reportData?.ForwardedBags.length > 0 ?
                            <>
                                <h4>Bags [Forwarded Via]</h4>
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>Reference Number</th>
                                            <th>Tag Number</th>
                                            <th>Received Date</th>
                                            <th>Rush Tag</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reportData?.ForwardedBags.map((bag, idx) => 
                                            <tr key={idx}>
                                                <td>{bag.case_file?.primary_reference}</td>
                                                <td>{bag.tag_number}</td>
                                                <td>{bag.receive_date ? moment(bag.receive_date).format("MMMM Do") : "-"}</td>
                                                <td>{bag.rush_tag_number || "-"}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <br />
                            </>
                        : null}
                        {(reportData?.OriginatedBags.length + reportData?.ReceivedBags.length + reportData?.ForwardedBags.length) > 0 ?
                            <><hr /><br /></>
                        : null}
                        {reportData?.FromTransferBags.length > 0 ?
                            <>
                                <h5>Transfer Bags - FROM</h5>
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>To Flight</th>
                                            <th>Total Bags</th>
                                            <th>Connected</th>
                                            <th>Tag Numbers</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reportData?.FromTransferBags.map((item, index) => 
                                            <tr key={index}>
                                                <td>{item.to_flight}</td>
                                                <td>{item.total_bags}</td>
                                                <td>{item.bags_connected}</td>
                                                <td>{item.tag_numbers}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <br />
                            </>
                        : null}
                        {reportData?.ToTransferBags.length > 0 ?
                            <>
                                <h5>Transfer Bags - TO</h5>
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>From Flight</th>
                                            <th>Total Bags</th>
                                            <th>Connected</th>
                                            <th>Tag Numbers</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reportData?.ToTransferBags.map((item, index) => 
                                            <tr key={index}>
                                                <td>{item.from_flight}</td>
                                                <td>{item.total_bags}</td>
                                                <td>{item.bags_connected}</td>
                                                <td>{item.tag_numbers}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <br />
                            </>
                        : null}
                        {(reportData?.FromTransferBags.length + reportData?.ToTransferBags.length + reportData?.OriginatedBags.length + reportData?.ReceivedBags.length + reportData?.ForwardedBags.length) === 0 ?
                            <h4 align="center">No Bags to Report</h4>
                        : null}
                    </div>
                    <div className="print-hidden modal-footer">
                        <button type="button" onClick={() => toggleModal({})} className="btn btn-secondary waves-effect" data-dismiss="modal">Close</button>
                        {(reportData?.FromTransferBags.length + reportData?.ToTransferBags.length + reportData?.OriginatedBags.length + reportData?.ReceivedBags.length + reportData?.ForwardedBags.length) > 0 ?
                            <>
                                <button type="button" onClick={() => mailFlight()} className="btn btn-info waves-effect">Email</button>
                                <button type="button" onClick={() => printForm({})} className="btn btn-primary waves-effect">Download</button>
                            </>
                        : null}
                    </div>
                </Modal>
            </div>
        </React.Fragment>
        
    )
    
}

export default FlightSummary;

